
import { Subject } from 'rxjs';

const subject = new Subject();

export const layerUpdateService = {
    sendLayer: layer => subject.next(layer),
    clearLayer: () => subject.next(),
    getLayer: () => subject.asObservable()
};